import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { getRandomName } from "./utils";

export const uploadWaiver = async (waiver) => {
  const fileName = `${getRandomName()}.pdf`;
  const metadata = {
    contentType: "application/pdf",
  };

  const storage = getStorage();
  const fileRef = ref(storage, `waivers/${fileName}`);

  const uploadTask = uploadBytesResumable(fileRef, waiver, metadata);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            console.log("Upload state: ", snapshot.state);
            break;
        }
      },
      (error) => {
        reject(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          resolve({ downloadURL, fullPath: fileRef.fullPath });
        });
      }
    );
  });
};
